import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
export var Spinner = AwsUi.__addComponent('awsui-spinner', {
    releaseStatus: 'stable',
    properties: {
        // Size of the spinner.
        size: {
            type: 'string',
            valid: ['normal', 'big', 'large'],
            defaultValue: 'normal'
        },
        // Color variant of the spinner. Please mind that the normal variant picks up the current color
        // of its context.
        variant: {
            type: 'string',
            valid: ['normal', 'disabled', 'inverted'],
            defaultValue: 'normal'
        }
    },
    render: function (m, h) {
        var cb = new LegacyClassBuilder(this);
        cb.addClass('awsui-spinner')
            .addPropertyValueClass('size')
            .addPropertyValueClass('variant')
            // simplified spinner can be also created by a css class
            // we need to distinguish that situation
            .addClass('awsui-spinner-component');
        return (AwsUi.__createElement("div", { className: cb.toClassName() },
            AwsUi.__createElement("div", { className: "awsui-spinner-circle awsui-spinner-circle-left" }),
            AwsUi.__createElement("div", { className: "awsui-spinner-circle awsui-spinner-circle-right" })));
    }
});
//# sourceMappingURL=index.js.map